// removed by extract-text-webpack-plugin
module.exports = {"container":"src-components-SingleClient-___clientPage__container___2DvHX","page-content":"src-components-SingleClient-___clientPage__page-content___1VhtN","block":"src-components-SingleClient-___clientPage__block___1ARtM","story-block":"src-components-SingleClient-___clientPage__story-block___1jw1q","news-title":"src-components-SingleClient-___clientPage__news-title___3Pf-v"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SingleClient/clientPage.css
// module id = 1073
// module chunks = 0